// Stevens Institute of Technology's undergraduate majors (#2839). Read on
// 2026-10-01 from the official 2026-2027 Academic Catalog
// (stevens.catalog.prod.coursedog.com, which stevens.edu's Academic Catalog
// page links as "Academic Catalog 2026-2027"), through the catalog's own
// program search (effective 2026-09-01): every program of type
// "Undergraduate Major", under the school the catalog names, with the
// catalog's degree designation. The catalog is hosted off stevens.edu, so
// each group cites the Academic Catalog page that links it. Names drop the
// "Bachelor of ... in" prefix; the Chemical Biology entry keeps the
// catalog's full name. Left out: minors, concentrations, dual degrees,
// graduate certificates and graduate programs.
const majors = {
    "slug": "stevens-institute-of-technology",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in Stevens' official 2026-2027 Academic Catalog, grouped by the school that offers it, with the degree it leads to. Minors, concentrations, dual degrees and graduate programs are left out.",
    "groups": [
        {
            "name": "Charles V. Schaefer, Jr. School of Engineering and Science",
            "source": {
                "label": "Stevens Academic Catalog 2026-2027 (from the Academic Catalog page), Charles V. Schaefer, Jr. School of Engineering and Science",
                "url": "https://www.stevens.edu/academics/academic-catalog"
            },
            "majors": [
                {
                    "name": "Biology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "Bachelor of Engineering"
                },
                {
                    "name": "Chemical Biology and Accelerated Chemical Biology Program",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "Bachelor of Engineering"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "Bachelor of Engineering"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "Bachelor of Engineering"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "Bachelor of Engineering"
                },
                {
                    "name": "Engineering Management",
                    "degree": "Bachelor of Engineering"
                },
                {
                    "name": "Engineering Physics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "Bachelor of Engineering"
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": "Bachelor of Engineering"
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "Bachelor of Engineering"
                },
                {
                    "name": "Ocean Engineering",
                    "degree": "Bachelor of Engineering"
                },
                {
                    "name": "Physics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Software Engineering",
                    "degree": "Bachelor of Engineering"
                }
            ]
        },
        {
            "name": "School of Computing",
            "source": {
                "label": "Stevens Academic Catalog 2026-2027 (from the Academic Catalog page), School of Computing",
                "url": "https://www.stevens.edu/academics/academic-catalog"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "School of Business",
            "source": {
                "label": "Stevens Academic Catalog 2026-2027 (from the Academic Catalog page), School of Business",
                "url": "https://www.stevens.edu/academics/academic-catalog"
            },
            "majors": [
                {
                    "name": "Accounting and Analytics",
                    "degree": "Bachelor of Science - Business"
                },
                {
                    "name": "Business and Technology",
                    "degree": "Bachelor of Science - Business"
                },
                {
                    "name": "Economics",
                    "degree": "Bachelor of Science - Business"
                },
                {
                    "name": "Finance",
                    "degree": "Bachelor of Science - Business"
                },
                {
                    "name": "Information Systems",
                    "degree": "Bachelor of Science - Business"
                },
                {
                    "name": "Management",
                    "degree": "Bachelor of Science - Business"
                },
                {
                    "name": "Marketing Innovation and Analytics",
                    "degree": "Bachelor of Science - Business"
                },
                {
                    "name": "Quantitative Finance",
                    "degree": "Bachelor of Science Quantitative Finance"
                }
            ]
        },
        {
            "name": "School of Humanities, Arts and Social Sciences",
            "source": {
                "label": "Stevens Academic Catalog 2026-2027 (from the Academic Catalog page), School of Humanities, Arts and Social Sciences",
                "url": "https://www.stevens.edu/academics/academic-catalog"
            },
            "majors": [
                {
                    "name": "Literature, Culture and Media",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Music and Technology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Philosophy",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Quantitative Social Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Science Communication",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Science, Technology and Society",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Visual Arts and Technology",
                    "degree": "Bachelor of Arts"
                }
            ]
        }
    ]
};

export default majors;
